import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-246c282e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Jerez Actúa", -1))
const _hoisted_3 = { class: "wrapper" }

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import {
  IonPage, IonHeader, IonFooter, IonToolbar, IonContent, IonTitle, IonIcon, IonCard, IonCardHeader,
  IonCardTitle, IonCardContent, onIonViewWillEnter, onIonViewDidLeave
} from '@ionic/vue'
import { enterOutline, helpOutline } from 'ionicons/icons'
import { App } from '@capacitor/app'
import { Toast } from '@capacitor/toast'

const MAX_BACK = 2

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


const publicPath = process.env.BASE_URL

const router = useRouter()
const back = ref<number>(0)

const goView = (name: string) => {
  router.push({ name })
}

const showToast = async () => {
  await Toast.show({
    text: 'Pulse otra vez para cerrar la app',
  });
};

watch(back, async val => {
  if (val === MAX_BACK)
    await App.exitApp()
  else if (val === MAX_BACK - 1)
    await showToast()
})

onIonViewWillEnter(() => {
  back.value = 0
  App.addListener('backButton', () => {
    back.value++
  })
})

onIonViewDidLeave(() => {
  App.removeAllListeners()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), {
                class: "ion-text-center",
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: `${_unref(publicPath)}img/logo.png`,
                    alt: "Logo Ayuntamiento de Jerez",
                    class: "escudo"
                  }, null, 8, _hoisted_1),
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(IonCard), {
              button: "",
              color: "secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goView('create')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardContent), { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(enterOutline),
                      class: "my-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardTitle), { class: "ion-text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Entrar")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCard), {
              button: "",
              color: "warning",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goView('help')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCardContent), { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(helpOutline),
                      class: "my-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCardHeader), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardTitle), { class: "ion-text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ayuda")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), {
                class: "ion-text-center",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Aviso de incidencias")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})